import { useEffect, useRef } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { NAVIGATION_GROUPS } from '../../navigation'
import type { AppSidebarProps } from './AppSidebar.types'
import './AppSidebar.css'

const ICON_SIZE = 18
const ICON_STROKE_WIDTH = 1.75

export function AppSidebar({
  isCollapsed,
  isDrawerOpen,
  onNavigate,
}: AppSidebarProps) {
  const navRef = useRef<HTMLElement>(null)

  useEffect(() => {
    if (!isDrawerOpen) {
      return
    }
    navRef.current?.querySelector<HTMLAnchorElement>('a')?.focus()
  }, [isDrawerOpen])

  return (
    <aside id="app-sidebar" className="app-sidebar">
      <Link
        to="/tenant-groups"
        className="app-sidebar__brand"
        aria-label="Tenancy and Inventory Management System home"
        onClick={onNavigate}
      >
        <span className="app-sidebar__brand-mark" aria-hidden="true">
          ATG
        </span>
        <span className="app-sidebar__brand-name">
          Tenancy and Inventory Management System
        </span>
      </Link>

      <nav
        ref={navRef}
        className="app-sidebar__nav"
        aria-label="Main navigation"
      >
        {NAVIGATION_GROUPS.map((group) => {
          const headingId = `app-sidebar-group-${group.label.toLowerCase()}`
          return (
            <section
              key={group.label}
              className="app-sidebar__group"
              aria-labelledby={headingId}
            >
              <h2 id={headingId} className="app-sidebar__group-label">
                {group.label}
              </h2>
              <ul className="app-sidebar__list">
                {group.items.map(({ label, to, icon: Icon }) => (
                  <li key={to}>
                    <NavLink
                      to={to}
                      title={isCollapsed ? label : undefined}
                      className={({ isActive }) =>
                        `app-sidebar__link${isActive ? ' active' : ''}`
                      }
                      onClick={onNavigate}
                    >
                      <Icon
                        className="app-sidebar__icon"
                        size={ICON_SIZE}
                        strokeWidth={ICON_STROKE_WIDTH}
                        aria-hidden="true"
                      />
                      <span className="app-sidebar__label">{label}</span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            </section>
          )
        })}
      </nav>
    </aside>
  )
}
